module.exports = __webpack_public_path__ + "static/media/ConnectDomainIllustration.c491fb41.svg";